import axios from "axios";

const method = (name) =>
    `method/restaurant_management.restaurant_storefront.api.${name}`;
const unwrap = (response) => response?.data?.message;

export const getErrorMessage = (error, fallback = "Something went wrong") => {
    const data = error?.response?.data || {};
    if (data._server_messages) {
        try {
            const messages = JSON.parse(data._server_messages);
            const first = JSON.parse(messages[0]);
            if (first?.message) return first.message.replace(/<[^>]+>/g, "");
        } catch {
            // Fall through to the regular response message.
        }
    }
    return data.message || data.exception || error?.message || fallback;
};

export const getOrderErrorMessage = (error) => {
    const data = error?.response?.data || {};
    const isInternalOrPermissionFailure =
        Number(error?.response?.status) >= 500 ||
        data.exc_type === "PermissionError" ||
        String(data.exception || "").includes("PermissionError");

    if (isInternalOrPermissionFailure) {
        return "We couldn't submit your order. Please try again or contact the restaurant.";
    }
    return getErrorMessage(error, "We couldn't submit your order. Please try again.");
};

export const getStorefrontAvailability = () =>
    axios
        .get(method("get_storefront_availability"), { timeout: 10 * 1000 })
        .then(unwrap);
export const getConfig = (tableToken) =>
    axios.get(method("get_config"), { params: { table_token: tableToken || undefined } }).then(unwrap);
export const getCatalog = ({ search, itemGroup } = {}) =>
    axios.get(method("get_catalog"), {
        params: { search: search || undefined, item_group: itemGroup || undefined },
    }).then(unwrap);
export const getSession = async () => {
    const session = await axios.get(method("get_session")).then(unwrap);
    if (session?.authenticated) {
        try {
            const token = await axios.get("method/custom_api.api.getToken").then(unwrap);
            if (token) axios.defaults.headers.common["x-frappe-csrf-token"] = token;
        } catch {
            // Read-only browsing should keep working if the token endpoint is unavailable.
        }
    }
    return session;
};
export const login = ({ username, password }) =>
    axios.post("method/login", { usr: username, pwd: password });
export const logout = () => axios.post("method/logout");
export const signUp = ({ email, fullName }) =>
    axios.post(method("sign_up"), { email, full_name: fullName }).then(unwrap);
export const updatePassword = ({ key, newPassword }) =>
    axios.post("method/frappe.core.doctype.user.user.update_password", {
        key,
        new_password: newPassword,
        logout_all_sessions: 1,
    }).then(unwrap);
export const getProfile = () => axios.get(method("get_profile")).then(unwrap);
export const quoteCart = (items) =>
    axios.post(method("quote_cart"), { items }).then(unwrap);
export const placeOrder = (payload) =>
    axios.post(method("place_order"), {
        items: payload.items,
        quote_hash: payload.quoteHash,
        idempotency_key: payload.idempotencyKey,
        table_token: payload.tableToken || undefined,
        notes: payload.notes || undefined,
        mobile_no: payload.mobileNo || undefined,
        address: payload.address || undefined,
    }).then(unwrap);
export const listMyOrders = () => axios.get(method("list_my_orders")).then(unwrap);
export const listStaffOrders = ({ status, search, customer } = {}) =>
    axios.get(method("list_staff_orders"), {
        params: {
            status: status && status !== "All" ? status : undefined,
            search: search || undefined,
            customer: customer || undefined,
        },
    }).then(unwrap);
export const getStaffOrder = (orderName) =>
    axios.get(method("get_staff_order"), { params: { order_name: orderName } }).then(unwrap);
export const rejectOrder = ({ orderName, reason }) =>
    axios.post(method("reject_order"), { order_name: orderName, reason }).then(unwrap);
export const listCustomers = (search) =>
    axios.get(method("list_storefront_customers"), { params: { search: search || undefined } }).then(unwrap);
export const listQrTables = () => axios.get(method("list_qr_tables")).then(unwrap);
export const regenerateQr = (tableName) =>
    axios.post(method("regenerate_table_qr"), { table_name: tableName }).then(unwrap);
